import Immutable from 'immutable';
import moment from 'moment';

import Url from 'sharedreact/data/Url';
import FolderEntry from 'sharedreact/data/FolderEntry';
import MomentSupport from 'sharedreact/utils/MomentSupport';
import Encode from 'sharedreact/utils/Encode';
import FileSupport from 'sharedreact/utils/FileSupport';
import ClassFactory from 'sharedreact/utils/ClassFactory';

const Content: {
  id: string,
  filename: string,
  folder: string,
  modificationDate: moment.Moment | null,
  fileSize: number,
  fileType: string
} = {
  id: '',
  filename: '',
  folder: '',
  modificationDate: null,
  fileSize: 0,
  fileType: ''
};

class UploadedFile extends Immutable.Record(Content) {
  static fromJS (json: object): UploadedFile {
    return ClassFactory.createFromJson(json, UploadedFile);
  }

  toUrl (): Url {
    return new Url({folder: this.folder, filename: this.filename});
  }

  toFolderEntry (): FolderEntry {
    return new FolderEntry({
      id: this.id,
      name: this.filename,
      url: this.toUrl().toString(),
      modificationDate: this.modificationDate,
      kind: 'file',
      fileType: this.fileType,
      fileSize: this.fileSize,
      jobId: null
    });
  }

  get fileUrl (): string | null {
    if (this.folder && this.filename) {
      const fileUrl = this.folder + '/' + this.filename.split('/').map((component) => FileSupport.strictEncodeURIComponent(component)).join('/');
      return Encode.normalizeHexChars(fileUrl);
    }
    return null;
  }

  get name (): string {
    return this.filename;
  }

  get extension (): string {
    const extensionSepPos: number = this.name.lastIndexOf('.');
    return extensionSepPos !== -1 ? this.name.substr(extensionSepPos + 1) : '';
  }

  get displayFileType (): string {
    return this.fileType || this.extension.toUpperCase();
  }
}

export default UploadedFile;
